
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/postsPage",
      function () {
        return require("private-next-pages/postsPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/postsPage"])
      });
    }
  